import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

export default WithDirection(styled.div`
    .subtitle {
        flex-grow: 1;
        margin-top: 14px;
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 300;
        color: rgba(219, 219, 219, 1);
        text-align: center;
        letter-spacing: 0.08em;
    }

    .header-wrapper + * { align-items: center; }
    .content-wrapper {
        width: 893px;
        padding: 42px 39px;
        background-color: rgba(255, 255, 255, 1);
    }

    .message {
        font-family: 'Montserrat';
        font-size: 16px;
        color: rgba(147, 147, 147, 1);
        text-align: center;
        letter-spacing: 0.08em;
    }

    button {
        display: flex;
        align-items: center;
        margin: 0 auto;
        margin-top: 42px;
        padding: 7px 21px;
        background-color: rgba(60, 211, 207, 1);
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        letter-spacing: 0.01em;
        text-transform: uppercase;
        border-radius: 21px;
    }
    button img { margin-left: 7px; width: 21px; height: auto; }

    @media screen and (max-width: 767px) {
        .content-wrapper {
            margin: 0 15px;
            width: auto;
            padding: 18px 16px;
        }

        button { padding: 7px 14px; }
    }
`);


// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/style.js